import type { ServerResponseV1 } from "@/http"
import type { EventWebsiteDTOData, EventWebsiteResponse } from "@/models"
import * as Sentry from "@sentry/vue"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"
import { EventWebsiteSchemaV1 } from "@/models"

interface IUpdateWebsiteFields {
  domainKey: string
  slug?: string
  isPublic: boolean
}

interface IUseUpdateWebsiteArgs extends IUpdateWebsiteFields {
  eventVaultId: number
}

export async function updateWebsite(eventVaultId: number, fields: IUpdateWebsiteFields): Promise<EventWebsiteDTOData> {
  const endpoint = `/events/${eventVaultId}/website/slug`
  const response = await v1.put<ServerResponseV1<EventWebsiteResponse>>(endpoint, fields)

  const result = EventWebsiteSchemaV1.safeParse(response.data.data)

  if (!result.success) {
    const message = "Failed to validate API response schema"
    Sentry.logger.error(message, {
      raw: response.data.data,
      endpoint,
      body: fields,
      method: "put",
    })

    throw new Error(message)
  }

  return result.data
}

export function useUpdateWebsite() {
  return useMutation({
    mutationFn: ({ eventVaultId, domainKey, slug, isPublic }: IUseUpdateWebsiteArgs) => updateWebsite(eventVaultId, {
      domainKey,
      slug,
      isPublic,
    }),
  })
}
